import getLocal from '@/app/utils/getLocal';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import classNames from 'classnames';
import React from 'react';
import EfImg from 'elem/ui/ef-img';
import './index.scss';
import { langText } from './langText';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartInventoryPolicy, ItfEcoCartItem } from 'eco-design-components/elements/eco-cart/type.d';
import gtm from 'eco-design-reliance/gtm';

export interface EfCardCartItemProps {
    /**
     * 产品 tag
     */
    tag?: string;
    /**
     * 产品 productId
     */
    productId?: string;
    /**
     * 产品 variantId
     */
    variantId?: string;
    /**
     * 默认购买数量
     */
    quantity?: number;
    /**
     * 库存
     */
    inventoryQuantity?: number;
    /**
     * 库存
     */
    inventoryPolicy?: ItfEcoCartInventoryPolicy;
    /**
     * 所有分辨率展示的资源链接
     */
    img?: string;
    /**
     * 所有分辨率展示的资源链接
     */
    variantImg?: string;
    /**
     * 主标题
     */
    productTitle?: string;
    /**
     * 主标题
     */
    skuTitle?: string;
    /**
     * 主标题
     */
    title: string;
    /**
     * subtitle描述文案
     */
    subtitle?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 产品原始价格
     */
    compareAtPrice?: number;
    /**
     * 产品折后价格
     */
    price?: number;
    /**
     * btnCartText
     */
    btnCartText?: string;
}

export interface EfCardCartListsProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * gtm list name
     */
    list_name?: string;
    /**
     * 商品列表
     */
    items?: EfCardCartItemProps[];
}

/**
 * 维护: kalkin
 *
 * 商品卡片列表 - 添加购物车
 */
const EfCardCartLists: React.FC<EfCardCartListsProps> = ({ items, className, list_name }) => {
    const prefixCls = `ef-card-cart-lists`;
    const prefix = `${prefixCls}-`;
    const { locale } = getLocal();
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const i18n = langText[locale] || langText['jp'];

    const handleAddToCart = (item: any) => {
        const { price, compareAtPrice, img, variantImg, inventoryPolicy, inventoryQuantity, productTitle, skuTitle, productId, variantId } = item;
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
            {
                price,
                compareAtPrice,
                img,
                variantImg,
                inventoryPolicy,
                inventoryQuantity,
                productTitle,
                skuTitle,
                productId,
                variantId,
                quantity: 1,
            } as ItfEcoCartItem,
        ]);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: item?.name || item?.title || productTitle || skuTitle,
            list_name: list_name || 'none',
            price,
            tag: 'none',
            quantity: 1,
            button_name: item?.btnCartText || i18n.cart,
        });
    };

    return (
        <div className={classes}>
            <ul className={`${prefix}cards`}>
                {items?.map((item: EfCardCartItemProps, k: number) => (
                    <li className={`${prefix}card${items?.some((list: EfCardCartItemProps) => list?.tag) ? ' has-tag' : ''}`} key={k}>
                        {item?.tag && <span className={`${prefix}card-tag`}>{item?.tag}</span>}
                        <div className={`${prefix}card-img`}>{item.img && <EfImg pc={item.img} />}</div>
                        <div className={`${prefix}card-info`}>
                            {item?.tag && <p className={`${prefix}info-label`}>{item?.tag}</p>}
                            {item?.title && <p className={`${prefix}info-title`}>{item?.title}</p>}
                            {item?.subtitle && <p className={`${prefix}info-subtitle`}>{item?.subtitle}</p>}
                            {item?.desc && <p className={`${prefix}info-desc`}>{item?.desc}</p>}
                        </div>
                        <div className={`${prefix}card-footer`}>
                            {item?.price && (
                                <div className={`${prefix}card-discount-price`}>
                                    {FormatMoneyLocal(item?.price, locale)}
                                    {<span className={`${prefix}card-price-suffix`}>{i18n.suffix}</span>}
                                </div>
                            )}
                            {item?.compareAtPrice && item?.compareAtPrice !== item?.price && (
                                <div className={`${prefix}card-original-price`}>
                                    {<span className={`${prefix}card-price-prefix`}>{i18n.prefix}</span>}
                                    {FormatMoneyLocal(item?.compareAtPrice, locale)}
                                    {<span className={`${prefix}card-price-suffix`}>{i18n.suffix}</span>}
                                </div>
                            )}
                            <button
                                className={`${prefix}card-add-cart${
                                    Number(item?.inventoryQuantity || 0) <= 0 && item?.inventoryPolicy !== 'continue' ? ' disable' : ''
                                }`}
                                onClick={() => handleAddToCart(item)}
                            >
                                {item?.btnCartText || i18n.cart}
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EfCardCartLists;
